exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".FormFieldGroup {\n  display: flex; }\n  .FormFieldGroup .FormField {\n    width: 50%; }\n    .FormFieldGroup .FormField:nth-child(2n + 1) {\n      padding-right: 16px; }\n    .FormFieldGroup .FormField:nth-child(2n + 2) {\n      padding-left: 16px; }\n", ""]);

// exports
